"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isPublicUrl = void 0;
const isPublicUrl = urls => {
  const currentPath = typeof window === 'object' ? window.location.pathname : '';
  for (let url of urls) {
    if (currentPath.includes(url)) return true;
  }
  return false;
};
exports.isPublicUrl = isPublicUrl;